<!--Loading Spinner-->
<div *ngIf="isProcessing">
  <app-spinner></app-spinner>
</div>

<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">

            <div class="col-sm-6">

            </div><!-- /.col -->

            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
                <li class="breadcrumb-item active">Payment Status</li>
              </ol>
            </div><!-- /.col -->
          </div><!-- /.row -->
        </div><!-- /.container-fluid -->
    </div>

    <div class="row">
        <div class="col">
          <form>
            <div class="row mb-2 align-items-center">
              <!-- Rows per page dropdown -->
              <div class="col-md-8 d-flex justify-content-end">
                <div class="d-flex align-items-center">
                  <label for="perPage" class="form-label me-2 mb-0">Rows per page:</label>&nbsp;
                  <select id="perPage"
                          class="form-select form-select-sm w-auto"
                          (change)="onPerPageChange($event)">
                    <option *ngFor="let option of perPageOptions"
                            [value]="option"
                            [selected]="option === itemsPerPage">
                      {{ option }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Search box -->
              <div class="col-md-4 d-flex justify-content-end">
                <input type="text"
                       class="form-control"
                       placeholder="Type BL No., Chassis No., Make or Model here to search..."
                       (input)="onSearchTextChange($event)">
              </div>
            </div>
          </form>
        </div>
    </div>
    </section>
      <!-- /.content-header -->
    <section class="content">
      <div class="container-fluid">
      <div class="card">
          <div class="card-header">
            <h3 class="card-title">Payment Status</h3>
            <!--Error Message-->
            <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
              {{errorMessage}}
            </div>
            <!--Success Message-->
            <div class="alert alert-success" role="alert" *ngIf="successMessage">
              {{successMessage}}
            </div>
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <table class="table table-bordered table-hover table-sm" *ngIf="!isProcessing">
              <thead class="table-light">
                <tr>
                  <th>BL Number</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Chassis Number</th>
                  <th>Duty</th>
                  <th>D.O</th>
                  <th>Radiation</th>
                  <th>Port Charges</th>
                  <th>IDF</th>
                  <th>Agency Fees</th>
                  <th>Agent Name</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let status of paymentStatuses| searchVehicle: searchText | paginate: { itemsPerPage: itemsPerPage, currentPage: page, totalItems: count }" [ngClass]="getRowClass(status.bl_no)">
                  <td>{{ status.bl_no}}</td>
                  <td>{{ status.make}}</td>
                  <td>{{ status.model}}</td>
                  <td>{{ status.chassis_no}}</td>
                  <td>{{ status.duty_paid === '0.00' ? 'Pending' : status.duty_paid | currency:'Kshs ' }}</td>
                  <td>{{ status.do_charges === '0.00' ? 'Pending' : status.do_charges | currency:'Kshs ' }}</td>
                  <td>{{ status.radiation_charges === '0.00' ? 'Pending' : status.radiation_charges | currency:'Kshs ' }}</td>
                  <td>{{ status.port_charges === '0.00' ? 'Pending' : status.port_charges | currency:'Kshs ' }}</td>
                  <td>{{ status.idf_charges === '0.00' ? 'Pending' : status.idf_charges | currency:'Kshs ' }}</td>
                  <td>{{ status.agency_fees === '0.00' ? 'Pending' : status.agency_fees | currency:'Kshs ' }}</td>
                  <td>{{ status.agent_name}}</td>
                </tr>
              </tbody>
            </table>
            <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
    </section>
